var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gradient-box",style:({ background: _vm.generateGradient() })})])
}
var staticRenderFns = []

export { render, staticRenderFns }